module.exports = __webpack_public_path__ + "img/02_L1.189a2e28.svg";